import { apiClient } from './client';

export const notesApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        getNotes: builder.query({
            query: (bookId: string) => ({
                url: '/api/notes',
                method: 'GET',
                params: { book_id: bookId },
            }),
        }),

        addNote: builder.mutation({
            query: (note) => ({
                url: '/api/notes',
                method: 'POST',
                body: note,
            }),
        }),

        deleteNote: builder.mutation({
            query: ({
                id,
                bookId,
            }: {
                id: number;
                bookId: string | number;
            }) => ({
                url: '/api/notes',
                method: 'DELETE',
                body: { id: id, book_id: bookId },
            }),
        }),
        updateNote: builder.mutation({
            query: ({
                id,
                bookId,
                text,
            }: {
                id: number;
                bookId: string;
                text: string;
            }) => ({
                url: `/api/notes`,
                method: 'PUT',
                body: { text: text, book_id: bookId, id: id },
            }),
        }),
    }),
});

export const {
    useGetNotesQuery,
    useLazyGetNotesQuery,
    useAddNoteMutation,
    useDeleteNoteMutation,
    useUpdateNoteMutation,
} = notesApi;
